import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddStaffFailedIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4976 25.5021C68.062 43.8068 62.8206 57.6083 47.1726 65.8731C37.2226 71.1285 25.767 74.9868 19.8893 84.5823C-1.51919 119.532 44.1152 148.28 73.4972 114C98.4156 84.9275 136.624 152.34 172.997 97.5C205.496 48.5007 138.997 -23.0008 87.4976 25.5021Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 52C51 50.8954 51.8954 50 53 50H147C148.105 50 149 50.8954 149 52V106C149 108.209 147.209 110 145 110H55C52.7909 110 51 108.209 51 106V52Z",
			fill: "url(#paint0_linear_9445_55961)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.275 50C53.2881 50 52.8978 48.7219 53.7164 48.1706L97.7656 18.5048C99.1163 17.5951 100.884 17.5951 102.234 18.5048L146.284 48.1706C147.102 48.7219 146.712 50 145.725 50H54.275Z",
			fill: "url(#paint1_linear_9445_55961)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82 72C82 65.3726 87.3726 60 94 60H106C112.627 60 118 65.3726 118 72V83H82V72Z",
			fill: "url(#paint2_linear_9445_55961)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51 51.7848C51 51.0035 51.8558 50.524 52.5222 50.9319L142.947 106.294C144.669 107.349 143.922 110 141.903 110H55C52.7909 110 51 108.209 51 106V51.7848Z",
			fill: "url(#paint3_linear_9445_55961)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149 51.7848C149 51.0035 148.144 50.524 147.478 50.9319L54.0263 108.147C53.1654 108.674 53.539 110 54.5485 110H145C147.209 110 149 108.209 149 106V51.7848Z",
			fill: "url(#paint4_linear_9445_55961)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 88,
			cy: 120,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39,
			cy: 35,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 100,
			cy: 48,
			r: 10,
			fill: "url(#paint5_linear_9445_55961)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.333 110C113.333 117.364 107.364 123.333 100 123.333C92.6363 123.333 86.6667 117.364 86.6667 110C86.6667 102.636 92.6363 96.6665 100 96.6665C107.364 96.6665 113.333 102.636 113.333 110Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100 102.333C100.552 102.333 101 102.781 101 103.333V111.333C101 111.886 100.552 112.333 100 112.333C99.4477 112.333 99 111.886 99 111.333V103.333C99 102.781 99.4477 102.333 100 102.333ZM100 114.333C100.552 114.333 101 114.781 101 115.333V116.667C101 117.219 100.552 117.667 100 117.667C99.4477 117.667 99 117.219 99 116.667V115.333C99 114.781 99.4477 114.333 100 114.333Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9445_55961",
				x1: 54.7373,
				y1: 53.0508,
				x2: 102.084,
				y2: 131.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9445_55961",
				x1: 54.7373,
				y1: 18.678,
				x2: 72.3662,
				y2: 71.5291,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_9445_55961",
				x1: 83.3729,
				y1: 61.1695,
				x2: 101.87,
				y2: 90.3974,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_9445_55961",
				x1: 54.7373,
				y1: 53.0508,
				x2: 102.084,
				y2: 131.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_9445_55961",
				x1: 145.263,
				y1: 53.0508,
				x2: 97.9157,
				y2: 131.121,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_9445_55961",
				x1: 90.7627,
				y1: 39.0169,
				x2: 108.559,
				y2: 56.9831,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAddStaffFailedIcon);
export { ForwardRef as ReactComponent };
